module.exports = __webpack_public_path__ + "static/media/ezgif.com-crop.2e1a87be.gif";